import { AgTechQueryParam, OdQueryParam } from "../enums";
import { helperFunctions } from "../helper";
import NetworkService from "../network/networkService";
import { Observable } from "rxjs";
import { ILocationCatalog, ILocationCatalogAllResponse } from "../models";
import { URLConfig } from "../network/urlStore";

export const getLocationMetaDataCatalog = (
  queryParams?: Array<{
    key: OdQueryParam;
    value: string[];
  }>
): Observable<ILocationCatalogAllResponse> => {
  let url = URLConfig.getLocationMetaDataCatalogURL();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as ILocationCatalogAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching Location Catalog data", error);
      }
    );
  });
};

export const getLocationMetaDataCatalogNextPage = (
  nextPageURI: string
): Observable<ILocationCatalogAllResponse> => {
  const url = URLConfig.getLocationMetaDataCatalogNextPageURL(nextPageURI);
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as ILocationCatalogAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching Location Catalog next page", error);
      }
    );
  });
};

export const getContentLengthForLocationMetaDataCatalog = (
  queryParams?: Array<{
    key: OdQueryParam;
    value: string[];
  }>
): Observable<number> => {
  let url = URLConfig.getLocationMetaDataCatalogURL();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.head(url)
      .then((res: any) => {
        subscriber.next(res?.contentLength ?? 0);
        subscriber.complete();
      })
      .catch((error: Error) => {
        subscriber.error(error);
        subscriber.next(0);
        console.log("Error while fetching Location Catalog count", error);
      });
  });
};

export const getAllLocationMetaDataCatalog = (
  queryParams?: Array<{
    key: OdQueryParam;
    value: string[];
  }>
): Observable<ILocationCatalog[]> => {
  let allLocationCatalog: ILocationCatalog[] = [];
  return new Observable((subscriber) => {
    const errorHandler = (error: any) => {
      subscriber.error(error);
    };

    const responseHandler = (response: ILocationCatalogAllResponse) => {
      const pageRows = (response as any)?.values ??  [];
      allLocationCatalog = [
        ...allLocationCatalog,
        ...pageRows,
      ];

      if (response.nextPageUri) {
        getLocationMetaDataCatalogNextPage(response.nextPageUri).subscribe({
          next: responseHandler,
          error: errorHandler,
          complete: () => {
            console.info("Completed fetching all location metadata catalog");
          },
        });
      } else {
        subscriber.next(allLocationCatalog);
        subscriber.complete();
      }
    };

    getLocationMetaDataCatalog(queryParams).subscribe({
      next: responseHandler,
      error: errorHandler,
      complete: () => {
        console.info("Completed fetching all location metadata catalog");
      },
    });
  });
};

export const updateLocationMetaDataCatalog = (
  requestPayload: any
): Observable<ILocationCatalogAllResponse> => {
  const url = URLConfig.getLocationMetaDataCatalogURL();
  return new Observable((subscriber) => {
    NetworkService.put(url, requestPayload).then(
      (res: unknown) => {
        const response = res as ILocationCatalogAllResponse;
        subscriber.next(response);
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while updating Location Catalog", error);
      }
    );
  });
};

export const getLocationApplicationCatalog = (
  queryParams?: Array<{
    key: OdQueryParam | AgTechQueryParam;
    value: string[];
  }>
): Observable<ILocationCatalogAllResponse> => {
  let url = URLConfig.getLocationApplicationCatalogURL();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as ILocationCatalogAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching Location Catalog data", error);
      }
    );
  });
};

export const getLocationApplicationCatalogNextPage = (
  nextPageURI: string
): Observable<ILocationCatalogAllResponse> => {
  const url = URLConfig.getLocationApplicationCatalogNextPageURL(nextPageURI);
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as ILocationCatalogAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching Location Catalog next page", error);
      }
    );
  });
};

export const getContentLengthForLocationApplicationCatalog = (
  queryParams?: Array<{
    key: OdQueryParam | AgTechQueryParam;
    value: string[];
  }>
): Observable<number> => {
  let url = URLConfig.getLocationApplicationCatalogURL();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.head(url)
      .then((res: any) => {
        subscriber.next(res?.contentLength ?? 0);
        subscriber.complete();
      })
      .catch((error: Error) => {
        subscriber.error(error);
        subscriber.next(0);
        console.log("Error while fetching Location Catalog count", error);
      });
  });
};

export const getAllLocationApplicationCatalog = (
  queryParams?: Array<{
    key: OdQueryParam | AgTechQueryParam;
    value: string[];
  }>
): Observable<ILocationCatalog[]> => {
  let allLocationCatalog: ILocationCatalog[] = [];
  return new Observable((subscriber) => {
    const errorHandler = (error: any) => {
      subscriber.error(error);
    };

    const responseHandler = (response: ILocationCatalogAllResponse) => {
      const pageRows = (response as any)?.values ?? [];
      allLocationCatalog = [
        ...allLocationCatalog,
        ...pageRows,
      ];

      if (response.nextPageUri) {
        getLocationApplicationCatalogNextPage(response.nextPageUri).subscribe({
          next: responseHandler,
          error: errorHandler,
          complete: () => {
            console.info("Completed fetching all location application catalog");
          },
        });
      } else {
        subscriber.next(allLocationCatalog);
        subscriber.complete();
      }
    };

    getLocationApplicationCatalog(queryParams).subscribe({
      next: responseHandler,
      error: errorHandler,
      complete: () => {
        console.info("Completed fetching all location application catalog");
      },
    });
  });
};

export const updateLocationApplicationCatalog = (
  requestPayload: any
): Observable<ILocationCatalogAllResponse> => {
  const url = URLConfig.getLocationApplicationCatalogURL();
  return new Observable((subscriber) => {
    NetworkService.put(url, requestPayload).then(
      (res: unknown) => {
        const response = res as ILocationCatalogAllResponse;
        subscriber.next(response);
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while updating Location Catalog", error);
      }
    );
  });
};

export const getApplicationAttributes = (
  queryParams?: Array<{
    key: AgTechQueryParam;
    value: string[];
  }>
): Observable<ILocationCatalogAllResponse> => {
  let url = URLConfig.getApplicationAttributesURL();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as ILocationCatalogAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching Application Attributes", error);
      }
    );
  });
};
